import { useFetchDashboardData } from '../use-fetch-dashboard';
import { useFetchDashboardCards } from '../use-fetch-dashboard-cards';
import { useDelayedOrders } from './charts/use-delayed-orders';
import { useMostOrderedDishes } from './charts/use-most-ordered-dishes';
import { useOrdersByCategory } from './charts/use-orders-by-category';
import { useOrdersByEmployee } from './charts/use-orders-by-employee';
import { useOrdersHeatmap } from './charts/use-orders-heatmap';
import { usePopularOrders } from './charts/use-popular-orders';
import { useDashboardMenuCards } from './use-dashboard-menu-cards';

export const useDashboardMenu = () => {
  useFetchDashboardData(['orders_by_category', 'menu_heat_map', 'orders_by_employee']);
  const { cards } = useFetchDashboardCards('menu');

  return {
    chartsData: [
      useOrdersByCategory(),
      useMostOrderedDishes(),
      usePopularOrders(),
      useDelayedOrders(),
      useOrdersHeatmap(),
      useOrdersByEmployee(),
    ],
    cards: useDashboardMenuCards(cards),
  };
};
